import { MIN_SHAPE_POINTS, type ShapeVertex } from '@repo/api-contracts';

/** 점 하나를 지운다. 남는 점이 최소 개수(3)보다 적어지거나 index 가 없으면 null. */
export const deleteVertexAt = (
  points: readonly ShapeVertex[],
  index: number,
): ShapeVertex[] | null => {
  if (points.length <= MIN_SHAPE_POINTS || points[index] === undefined) return null;
  return points.filter((_, position) => position !== index);
};
